import { bindable, autoinject } from 'aurelia-framework';
import { SideBar } from '../../../components/side-bar/side-bar';

@autoinject
export class RowGeneratorApplyChanges {
	@bindable apply: () => Promise<any>;

	constructor(private sideBar: SideBar) {
	}

	async applyParameterChanges() {
		const isValid =	await this.apply();
		if (isValid) {
			this.sideBar.closeSuccess();
		}
	}
}
